import React, { useState, useEffect, useRef } from 'react';

import ItemModal from './ItemModal'
import Item from './Item'
import ComponentToolbar from './ComponentToolbar'

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import Tooltip from '@material-ui/core/Tooltip';

import TextField from "@material-ui/core/TextField";
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';

import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import FolderSpecialOutlinedIcon from '@material-ui/icons/FolderSpecialOutlined';
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import { Input } from '@material-ui/core';

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: theme.palette.secondary.light,
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  title: {
    flex: '1 1 100%',
  },
  invetoryIcons: {
    flex: '1 1 30%',
  },
  invetorySpace: {
    width: '50px'
  }
}));

const Inventory = ({ inventory, setInventory }) => {
  const classes = useToolbarStyles();

  const [itemsRow, setItemsRow] = useState('Loading...');
  const [weight, setWeight] = useState(0)
  const [money, setMoney] = useState(inventory.money)

  const addItemModal = useRef(ItemModal)

  useEffect(() => {
    setItemsRow(setItemsHandler(inventory.items))
    setWeight(calculateWeight())
  }, [inventory])

  useEffect(()=>{
    setInventory({ ...inventory, money: money })
  },[money])

  const setItemsHandler = (newItems) => (
    newItems.map((item) => (
      <Item
        key={item.name}
        name={item.name}
        description={item.description}
        weight={item.weight}
        quantity={item.quantity}
        removeItem={(itemName) => modifyQuantityItem(itemName, -1)}
        addItem={(itemName) => modifyQuantityItem(itemName, +1)}
      />
    ))
  )

  const onChangeSpace = (e) => {
    let fieldValue = e.target.value
    setInventory({ ...inventory, backpackWeight: fieldValue })
  }

  const handleItemModal = () => {
    addItemModal.current.handleOpen();
  }

  const addNewItem = (name, description, weight, quantity) => {
    let inventoryItems = inventory
    // console.log(inventoryItems)
    inventoryItems.items.push({ name: name, description: description, weight: weight, quantity: quantity })
    console.log(inventoryItems)

    setInventory({ ...inventoryItems })

  }

  const modifyQuantityItem = (itemName, quantity) => {
    let inventoryItems = inventory
    let item = inventoryItems.items.find(item => item.name === itemName)
    inventoryItems.items = inventory.items.filter(item => item.name !== itemName)
    let itemQuantity = Number(item.quantity)
    item.quantity = itemQuantity += quantity
    if (item.quantity <= 0) {
      removeItem(itemName)
      return
    }
    inventoryItems.items.push(item)
    console.log(inventoryItems)
    // item.quantity += quantity



    setInventory({ ...inventoryItems })

  }

  const removeItem = (itemName) => {
    console.log(itemName)
    let inventoryItems = inventory
    inventoryItems.items = inventory.items.filter(item => item.name !== itemName)
    console.log(inventoryItems)

    setInventory({ ...inventoryItems })
  }

  const calculateWeight = () => {
    let totalWeight = 0
    inventory.items.map((item) => totalWeight += Number(item.weight) * item.quantity)
    return totalWeight
  }



  return (
    <React.Fragment>
      <ComponentToolbar
        title={"Inventario"}
      >
        <Grid item>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Input type={'number'} value={money} onChange={(e) => setMoney(e.target.value)} style={{width: '100px'}}/>
            <AccountBalanceWalletOutlinedIcon />
          </Grid>
        </Grid>
        <Grid item>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
          // spacing={3}
          >
            <Typography>{weight} /&nbsp;</Typography>
            <TextField
              // className={classes.invetorySpace}
              // helperText="Tamanho do inventario"
              value={inventory.backpackWeight}
              select
              onChange={(e) => { onChangeSpace(e) }}>
              {[30, 40].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
            <FolderSpecialOutlinedIcon px={2} />
          </Grid>
        </Grid>

        <Grid item>
          <Tooltip title="Adicionar item">
            <IconButton onClick={() => handleItemModal()}>
              <AddIcon />
            </IconButton>
          </Tooltip>
        </Grid>
      </ComponentToolbar>

      <TableContainer
        className={classes.paper}
      >
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox"></TableCell>
              <TableCell>Nome</TableCell>
              <TableCell>Descrição</TableCell>
              <TableCell>Peso</TableCell>
              <TableCell align="right">Quantidade</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {itemsRow}
          </TableBody>
        </Table>
      </TableContainer>

      <ItemModal
        ref={addItemModal}
        handleAddItem={addNewItem}
      />

    </React.Fragment>
  );
}

export default Inventory;